/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsurancePayor
 */
export interface InsurancePayor {
    /**
     * 
     * @type {string}
     * @memberof InsurancePayor
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InsurancePayor
     */
    name: string;
}

/**
 * Check if a given object implements the InsurancePayor interface.
 */
export function instanceOfInsurancePayor(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function InsurancePayorFromJSON(json: any): InsurancePayor {
    return InsurancePayorFromJSONTyped(json, false);
}

export function InsurancePayorFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsurancePayor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function InsurancePayorToJSON(value?: InsurancePayor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

